(function () {
  if (window.ftKortingSheetsInitialized) return;
  window.ftKortingSheetsInitialized = true;

  var storageKey = 'ftKortingSheetsQueue';
  var maxAge = 24 * 60 * 60 * 1000;
  var busy = false;
  var retryTimer;
  var attempts = 0;

  function readQueue() {
    try {
      var queue = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      return Array.isArray(queue) ? queue.filter(function (item) {
        return item && item.created > Date.now() - maxAge;
      }) : [];
    } catch (err) {
      return [];
    }
  }

  function saveQueue(queue) {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(queue));
    } catch (err) {}
  }

  function getEndpoint() {
    var section = document.querySelector('[data-ft-sheets-url]');
    var url = section ? section.getAttribute('data-ft-sheets-url') : '';
    return /^https:\/\/script\.google\.com\/macros\/s\/[\w-]+\/exec$/.test(url) ? url : '';
  }

  function capture(event) {
    var form = event.target;
    if (!getEndpoint() || !form.matches('.ft-korting__form') || !form.checkValidity()) return;
    var fields = Object.fromEntries(new FormData(form).entries());
    var payload = {};
    var mapping = {
      name: 'name', email: 'email', telephone: 'phone', product: 'product_title',
      product_id: 'product_id', sku: 'Product-SKU', product_price: 'Prijs',
      product_category: 'product_type', message: 'body', referrer: 'Product-URL'
    };
    Object.keys(mapping).forEach(function (key) {
      payload[key] = fields['contact[' + mapping[key] + ']'] || '';
    });
    var params = new URLSearchParams(window.location.search);
    ['gclid', 'fbclid'].forEach(function (key) {
      payload[key] = params.get(key) || fields['contact[' + key + ']'] || '';
      if (!payload[key]) {
        try { payload[key] = sessionStorage.getItem(key) || ''; } catch (err) {}
      }
    });
    payload.form_type = 'kortingsaanvraag';
    payload.submission_id = window.crypto.randomUUID();
    var queue = readQueue().filter(function (item) {
      return item.confirmed || item.payload.product_id !== payload.product_id;
    });
    queue.push({ created: Date.now(), confirmed: false, payload: payload });
    saveQueue(queue);
  }

  function confirmSubmission() {
    var success = document.querySelector('[data-ft-sheets-success]');
    if (!success) return;
    var productId = success.getAttribute('data-ft-sheets-success');
    var queue = readQueue();
    queue.forEach(function (item) {
      if (item.payload.product_id === productId) item.confirmed = true;
    });
    saveQueue(queue);
  }

  function flush() {
    var endpoint = getEndpoint();
    if (!endpoint || busy || navigator.onLine === false) return;
    var entry = readQueue().find(function (item) { return item.confirmed; });
    if (!entry) return;
    busy = true;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 20000);
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(entry.payload),
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Sheets delivery failed');
      return response.json();
    }).then(function (result) {
      if (!result.ok || result.submission_id !== entry.payload.submission_id) {
        throw new Error('Sheets delivery not acknowledged');
      }
      saveQueue(readQueue().filter(function (item) {
        return item.payload.submission_id !== entry.payload.submission_id;
      }));
      attempts = 0;
      busy = false;
      clearTimeout(timeout);
      flush();
    }).catch(function () {
      clearTimeout(timeout);
      busy = false;
      attempts += 1;
      if (attempts <= 4) retryTimer = setTimeout(flush, Math.min(30000, 1000 * Math.pow(3, attempts)));
    });
  }

  function init() {
    confirmSubmission();
    flush();
  }

  document.addEventListener('submit', capture, true);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('online', function () {
    attempts = 0;
    clearTimeout(retryTimer);
    flush();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
